import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/parent-communication-chats', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/parent-communication-chats/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const sendMessage = data => {
  return httpClient
    .post('/api/parent-communication-chats', data, {
      headers: {
        'X-Socket-ID': Echo.socketId()
      }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/parent-communication-chats/${data.company_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/parent-communication-chats/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const storeChatGroup = data => {
  return httpClient
    .post('/api/parent-communication-chats/new-chat-groups', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const chatroom = (Options = {}) => {
  return httpClient
    .get('/api/parent-communication-chats/chat-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const classRooms = ac_status_id => {
  return httpClient
    .get(`/api/parent-communication-chats/class-rooms/${ac_status_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const users = (Options = {}) => {
  return httpClient
    .get('/api/parent-communication-chats/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  sendMessage,
  update,
  destroy,
  chatroom,
  storeChatGroup,
  users,
  classRooms
}
